import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { MarkupList, MarkupRecursiveList } from '@atlassian/forge-ui-types';
import { InlineContext } from '../../../context/inline';
import { Text } from '@atlaskit/primitives';

// exported for testing
export function toParagraphs(text) {
  return text.split(/\s*\n\s*\n[\n\s]*/).filter(function (str) {
    return str.length > 0;
  });
}
export function TextPlain(_ref) {
  var content = _ref.content;
  return jsx("div", null, toParagraphs(content).map(function (paragraph, i) {
    return jsx(Text, {
      as: "p",
      key: i
    }, paragraph);
  }));
}
var ALIGN_ALLOWLIST = ['start', 'center', 'end'];
var isTextAlign = function isTextAlign(align) {
  return ALIGN_ALLOWLIST.includes(align);
};
export function validateAlign(align) {
  if (isTextAlign(align)) {
    return align;
  } else {
    return 'start';
  }
}
export function TextMarkup(_ref2) {
  var children = _ref2.children,
    align = _ref2.align;
  var sanitizedAlign = validateAlign(align);
  return jsx(InlineContext.Provider, {
    value: {
      inline: true
    }
  }, jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      textAlign: sanitizedAlign
    })
  }, children));
}
function filterMarkup(children, nested) {
  var isNestable = function isNestable(child) {
    return MarkupRecursiveList.some(function (x) {
      return child.type === x;
    });
  };
  var isInline = function isInline(child) {
    return MarkupList.some(function (x) {
      return child.type === x;
    });
  };
  return children.map(function (child) {
    if (nested) {
      if (!isNestable(child)) {
        return null;
      }
    } else {
      if (!isInline(child)) {
        return null;
      }
    }
    return _objectSpread(_objectSpread({}, child), {}, {
      children: filterMarkup(child.children, true)
    });
  }).filter(function (x) {
    return x !== null;
  });
}
export function TextMarkupFn(_ref3) {
  var Components = _ref3.Components,
    children = _ref3.children,
    align = _ref3.align,
    dispatch = _ref3.dispatch,
    render = _ref3.render,
    renderChildren = _ref3.renderChildren;
  // filter non Markup components
  children = filterMarkup(children, false);
  return jsx(TextMarkup, {
    align: align
  }, renderChildren({
    Components: Components,
    children: children,
    render: render,
    dispatch: dispatch
  }));
}
export function TextFn(_ref4) {
  var props = _ref4.props,
    children = _ref4.children,
    type = _ref4.type,
    dispatch = _ref4.dispatch,
    render = _ref4.render,
    renderChildren = _ref4.renderChildren,
    Components = _ref4.Components;
  var _ref5 = props,
    content = _ref5.content,
    format = _ref5.format;
  if (typeof content === 'string') {
    return jsx(TextPlain, {
      content: content
    });
  }
  if (format === 'markup') {
    var _ref6 = props,
      align = _ref6.align;
    return TextMarkupFn({
      children: children,
      align: align,
      type: type,
      dispatch: dispatch,
      render: render,
      renderChildren: renderChildren,
      Components: Components
    });
  }

  // otherwise, do nothing
  return null;
}